/** Reading a Customer Portal hand-off link: /shared/<share>#access=<token>. Kept apart from the page so it tests
 * without loading the editor. */

/** The share this page was opened for, from /shared/<share>. */
export function shareFromPath(pathname: string): string | null {
    const match = /^\/shared\/([0-9a-fA-F-]{36})\/?$/.exec(pathname);
    return match ? match[1] : null;
}

/** The token in a #access=... fragment, or null. */
export function tokenFromHash(hash: string): string | null {
    const value = new URLSearchParams(hash.replace(/^#/, "")).get("access");
    return value && value.length > 20 ? value : null;
}
